import styles from "./landing-page-four.module.css";
import { HeaderSection } from "./sections/header-section";
import { ExamplesSection } from "./sections/examples-section";
// import { InstructionsSection } from "./sections/instructions-section";
import { ValuePropSection } from "./sections/value-prop-section";
import { PhysicalSection } from "./sections/physical-section";
import { StravaSection } from "./sections/strava-section";
import { PresetsSection } from "./sections/presets-section";
import { ActivitiesSection } from "./sections/activities-section";
import { BenefitsSection } from "./sections/benefits-section";
import { TestimonialSection } from "./sections/testimonial-section";
import { AppSection } from "./sections/app-section";
import { FooterSection } from "./sections/footer-section";
import { usePaths } from "BEDROCK/paths";
import { EndSection } from "./sections/end-section";

interface LandingPageFourProps {}

export const LandingPageFour = (props: LandingPageFourProps) => {
  const paths = usePaths();
  const startDesigning = () => {
    paths.navigateTo(paths.collectionList + "/A");
  };

  return (
    <div className={styles.parallaxContainer}>
      <div className={styles.backgroundContainer}></div>
      <div className={styles.foregroundContainer}>
        <HeaderSection onClickStart={startDesigning} />
        <ExamplesSection onClickExample={startDesigning} />
        <ValuePropSection onClick={startDesigning} />

        <PhysicalSection />
        <StravaSection collectionListHandle="A" />
        {/* <InstructionsSection onClick={startDesigning} /> */}
        <PresetsSection onClickTemplate={startDesigning} />
        {/* <ActivitiesSection /> */}
        <BenefitsSection />
        <AppSection />
        <EndSection onClickCTA={startDesigning} />
        <FooterSection />
      </div>
    </div>
  );
};
